import jQuery from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import LazyEmbed from 'lazyembed2';
import objectFitVideos from 'object-fit-videos';
import PageLoadedQueue from "./PageLoadedQueue";

window.jQuery = window.$ = jQuery;
window.LazyLoad = LazyLoad;
window.LazyEmbed = LazyEmbed;
window.objectFitVideos = objectFitVideos;
window.PageLoadedQueue = PageLoadedQueue;
